import { markRaw } from "vue";

export const getDefaultState = () => {
  return {
    currentModal: {
      showModal: false,
      modal: null
    }
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getCurrentModal(state) {
    return state.currentModal;
  }
};

// actions
const actions = {
  showModal({ commit }, modal) {
    commit("setCurrentModal", { showModal: true, modal });
  },
  hideModal({ commit }) {
    commit("setCurrentModal", { showModal: false, modal: null });
  }
};

// mutations
const mutations = {
  setCurrentModal(state, currentModal) {
    state.currentModal = markRaw(currentModal);
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
